import modalStyle from '../../modalStyle'

const editUserModalStyle = (theme) => ({
  ...modalStyle(theme),
  // modalHeader: {
  //   borderBottom: "1px solid rgb(0, 0, 0)"
  // }
})

export default editUserModalStyle